import { createChangeTableSettingAction } from '../../../../form/state/table-state-helper'
import * as type from './type'
import { loadFoilList } from '../../../api'

export const changeTableSetting = createChangeTableSettingAction(type.CHANGE_TABLE_SETTING)

export const findFoilListRequest = () => ({
    type: type.FIND_FOIL_LIST_REQUEST,
    payload: {},
})

export const findFoilListSuccess = (foilList) => ({
    type: type.FIND_FOIL_LIST_SUCCESS,
    payload: {
        foilList,
    },
})

export const findFoilListError = (error) => ({
    type: type.FIND_FOIL_LIST_ERROR,
    payload: {
        error,
    },
})

export const getFoilList = () => (dispatch, getState) => {
    dispatch(findFoilListRequest())

    loadFoilList()
        .then(foilList => {
            dispatch(findFoilListSuccess(foilList))
        })
        .catch(error => {
            dispatch(findFoilListError(error))
        })
}



// WEBPACK FOOTER //
// ./src/modules/foil/state/overview/info-table/action.js